import React, {Component} from 'react'
import {injectIntl} from 'react-intl'
import {ACTION_USER_LOGGED_OUT} from '../constants'
import {connect} from "react-redux"
import { Link } from 'react-router'
import {FormattedMessage} from "react-intl"
import {confirm} from '../util/AlertUtil'
import swal from 'sweetalert'
import {COLOR_VERY_NEGATIVE, COLOR_VERY_POSITIVE} from '../constants'


function mapStateToProps(state, ownProps) {
  return {
    router: state.router
  }
}

const mapDispatchToProps = {
  logout: () => {
    return {
      type: ACTION_USER_LOGGED_OUT
    }
  }
}


class LogoutLink extends Component{

  logout = (e) => {
    e.stopPropagation()

    const format = this.props.intl.formatMessage

    swal({
      title:`${format({id:'are.you.sure'})}?`,
      text:`${format({id:'message.logout'})}.`,
      type:'warning',
      showCancelButton: true,
      confirmButtonColor: COLOR_VERY_POSITIVE,
      confirmButtonText:format({id:'logout'}),
      cancelButtonColor:COLOR_VERY_NEGATIVE,
      cancelButtonText:format({id:'cancel'}),
      customClass: 'logout',
      closeOnConfirm: true
    }, ()=>{this.props.logout()})
  }

  render(){
    return (
      <Link to={this.props.router.locationBeforeTransitions.pathname} onClick={this.logout}>
        <i className="fa fa-sign-out-alt fa-lg"></i>
        <span className="nav-label">
          <FormattedMessage
            id="button.logout"
            defaultMessage={`Log out`}
          />
        </span>

      </Link>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LogoutLink))



// WEBPACK FOOTER //
// ./src/components/LogoutLink.js